export const navigationEN = {
  courses: 'Courses',
  payments: 'Packages',
  classes: 'Classes'
}
